// extracted by mini-css-extract-plugin
export default {"footerText":"FooterText_footerText__jVbUZ","text":"FooterText_text__hkBYk","textSpan":"FooterText_textSpan__MSVAh"};